import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  Order,
  PageSignature,
  PaymentMethod,
  SelectedMethod,
} from '../types/payment';

export interface PaymentState {
  selectedMethod: SelectedMethod;
  paymentMethod: PaymentMethod | null;
  signature: PageSignature | null;
  order: Order | null;
  error: string | null;
}

const initialState: PaymentState = {
  selectedMethod: '',
  paymentMethod: null,
  signature: null,
  order: null,
  error: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setSelectedMethod(state, action: PayloadAction<SelectedMethod>) {
      state.selectedMethod = action.payload;
    },
    setPaymentMethod(state, action: PayloadAction<PaymentMethod>) {
      state.paymentMethod = action.payload;
    },
    setSignature(state, action: PayloadAction<PageSignature | null>) {
      state.signature = action.payload;
    },
    setOrder(state, action: PayloadAction<Order | null>) {
      state.order = action.payload;
    },
    setPaymentError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setSelectedMethod,
  setPaymentMethod,
  setSignature,
  setOrder,
  setPaymentError,
} = paymentSlice.actions;

export default paymentSlice.reducer;
